<template>
    <div>
        <el-container v-loading.body="loading" :id="'SiloMetricsChart' + metricType" :class="loading? 'empty-card':''">
        </el-container>
    </div>

</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import siloImg from "../siloImg";

    export default {
        name: "SiloMetricsChart",
        components: {
            "siloImg": siloImg
        },
        props: {
            metricType: {
                type: String,
                required: true,
                validator: function (value) {
                    return ['temperature', 'humidity', 'co2'].indexOf(value.toLowerCase()) !== -1
                }

            },
            metricData: {
                type: Array,
                required: false,
            }
        },

        data: function () {
            return {
                chart: undefined,
                loading: true,
                h: "center"
            }
        },
        computed: {
            chartData: function () {
                let data = this.metricData.map((value, index) => {
                    return {
                        "section": this.$t("COMMON.SECTION") + " " + (index + 1),
                        "metricValue": value,
                        "img": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA/CAYAAABQHc7KAAAABmJLR0QAwQC8ALwjpYLHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QURAQI3usBwtwAAAMRJREFUaN7t2EEOgjAQBdBpY7yWG47NxoPpuHDjgoRgAZG+n7CENI/pTKHcxzFj49yGoaz9zLXWXfYA+AZor3UdAuCXqdF5AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAegBIFdA5QFEBAAAAAAAAAAAAAAAA8DncIcAzekaoJR4Nt+fH9Z+5ZFzjXQURy/8NlDNsgb57YT3T2zQGAQBYPgXmx1xLj8jD95c6P+ZyAmPJ+SAjms4a2+YFWzclH3YVrKEAAAAASUVORK5CYII="
                    }
                });

                return data;

            },
            metric: function () {
                return this.$t("COMMON." + this.metricType.toUpperCase())
            },
            unit: function () {
                switch (this.metricType) {
                    case "temperature":
                        let tempUnit = "C°";
                        if (this.$store.state.user !== undefined && this.$store.state.user.units !== undefined) {
                            let split = this.$store.state.user.units.split(",");
                            if (split !== undefined && split.length > 0 && split[0] === "F") {
                                tempUnit = "F"
                            }
                        }
                        return tempUnit;
                    case "humidity":
                        return "%";
                    case "co2":
                        let co2Unit = "ppm";
                        if (this.$store.state.user !== undefined && this.$store.state.user.units !== undefined) {
                            let split = this.$store.state.user.units.split(",");
                            if (split !== undefined && split.length > 0 && split[1] === "%") {
                                co2Unit = "%"
                            }
                        }
                        return co2Unit;
                }

            }
        },
        mounted() {
            setTimeout(() => {
                this.createChart();
            }, 1000);
            this.loading = true;

        },
        methods: {
            createChart() {
                let chart = am4core.create('SiloMetricsChart' + this.metricType, am4charts.XYChart);
                am4core.options.commercialLicense = true;
                this.chart = chart;
                chart.events.on('ready', () => {
                    this.loading = false;
                });
                chart.numberFormatter.numberFormat = "#.#\t" + this.unit;

                chart.data = this.chartData;

                let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "section";
                categoryAxis.renderer.labels.template.disabled = true;
                categoryAxis.renderer.grid.template.disabled = true;
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.inside = true;
                //chart.paddingBottom = 0;

                let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.grid.template.disabled = true;
                valueAxis.min = 0;
                valueAxis.renderer.baseGrid.disabled = true;
                //valueAxis.strictMinMax = true;
                let series = chart.series.push(new am4charts.LineSeries());


                series.dataFields.valueY = "metricValue";
                series.dataFields.categoryX = "section";

                series.tensionX = 0.8;
                series.tensionY = 1;
                series.strokeWidth = 2;
                series.connect = false;


                series.tooltip.getFillFromObject = false;
                series.tooltip.background.fill = am4core.color("#212121");
                series.tooltip.background.fillOpacity = 0.7;
                series.tooltip.background.strokeWidth = 0;


                let bullets = series.bullets.push(new am4charts.Bullet());
                let image = bullets.createChild(am4core.Image);
                image.propertyFields.href = "img";
                image.horizontalCenter = "middle";
                image.verticalCenter = "top";
                image.height = am4core.percent(100);

                //bullets.tooltipText = "{categoryX}\n " + this.metric + ": {valueY}";
            }
        },
        beforeDestroy() {
            if (this.chart !== undefined) {
                this.chart.dispose()
            }
        }
    }
</script>

<style>
    .empty-card {
        height: 100px;
    }

</style>